// Sdileny format casu zpravy (H:MM, bez vedouci nuly u hodin) - drive
// duplikovany nezavisle v TeamBottomSheet.vue a PlayerChatPopup.vue.
export function messageTime(time) {
    const d = new Date(time);
    const minutes = d.getMinutes();
    return d.getHours() + ':' + (minutes < 10 ? '0' + minutes : minutes);
}
